import React, { Component } from "react"
import { Button, Card, CardBody, Col } from "reactstrap"
import ReactApexChart from "react-apexcharts"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { registerUser, registerUserFailed } from "../../store/auth/register/actions"
import { getDashboardData } from "../../store/dashboard/actions"
import { apiError } from "../../store/auth/login/actions"
import Loader from "react-loader-spinner"
import { setUserPreference } from "../../store/auth/profile/actions"
import {withTranslation} from "react-i18next";
import Tooltip from "../../components/Common/tooltip";

class VendasCanal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      graphType:
        props.preferences && props.preferences.Grafico_Vendas_Canal
          ? props.preferences.Grafico_Vendas_Canal
          : "value",
      canais: {
        'SALAO': props.t('dashboard.lista.valorCanal.SALAO.title'),
        'BALCAO': props.t('dashboard.lista.valorCanal.BALCAO.title'),
        'DELIVERY': props.t('dashboard.lista.valorCanal.DELIVERY.title'),
        'TOTEM': props.t('dashboard.lista.valorCanal.TOTEM.title') }
      }
    }

  static abbreviateNumber(num, fixed) {
    if (num === null) {
      return null
    } // terminate early
    if (num === 0) {
      return "0"
    } // terminate early
    fixed = !fixed || fixed < 0 ? 0 : fixed // number of decimal places to show
    var b = num.toPrecision(2).split("e"), // get power
      k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
      c =
        k < 1
          ? num.toFixed(0 + fixed)
          : (num / Math.pow(10, k * 3)).toFixed(1 + fixed), // divide by power
      d = c < 0 ? c : Math.abs(c), // enforce -0 is 0
      e = d + ["", "K", "M", "B", "T"][k] // append power
    return e
  }

  static describePercentage(A, B) {
    A = parseFloat(A)
    B = parseFloat(B)

    return A && B ? (100 * Math.abs(A / B)).toFixed(2) : 0
  }

  static getDerivedStateFromProps(props, current_state) {

    const canaisName = canal => {
      return current_state.canais[canal]
    }
    if (props.dashboardValoresPorCanal) {

      let valoresPeriodo = props.dashboardValoresPorCanal.periodo ? props.dashboardValoresPorCanal.periodo[0] : []

      const totalizadores = valoresPeriodo.reduce((acc, item) => {
        return {
          Ticket_Medio_Pessoa: acc.Ticket_Medio_Pessoa + (item.Ticket_Medio_Pessoa || 0),
          Ticket_Medio: acc.Ticket_Medio + (item.Ticket_Medio || 0),
          Valor_Total: acc.Valor_Total + (item.Valor_Total || 0),
        }
      }, {
        Ticket_Medio_Pessoa: 0,
        Ticket_Medio: 0,
        Valor_Total: 0,
      })

      return {
        ...props,
        ...{
          options: {
            grid: {
              zlevel: 0,
              x: 50,
              x2: 50,
              y: 30,
              y2: 30,
              borderWidth: 0,
              backgroundColor: "rgba(0,0,0,0)",
              borderColor: "rgba(0,0,0,0)"
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                crossStyle: {
                  color: "#999"
                }
              }
            },
            toolbox: {
              feature: {
                dataView: { show: false, readOnly: false },
                magicType: { show: false, type: ["line", "bar"] },
                restore: { show: false },
                saveAsImage: { show: false }
              }
            },
          },
          chart_options: {
            chart: {
              toolbar: {
                show: false
              }
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "45%",
                endingShape: "rounded"
              }
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              show: true,
              width: 2,
              colors: ["transparent"]
            },

            colors: ["#34c38f", "#556ee6", "#f8b425"],
            xaxis: {
              categories:
                valoresPeriodo
                  ? valoresPeriodo.map(e =>
                    canaisName(e.Canal)
                  )
                  : []
            },
            yaxis: {
              title: {
                text:
                  current_state.graphType === "percentual"
                    ? props.t('dashboard.lista.valorCanal.percentual.label')
                    : props.t('dashboard.lista.valorCanal.valor.label')
              },
              labels: {
                formatter: function(val, object) {
                  if(current_state.graphType === "percentual") {
                    return `${val}%`
                  } else {
                    return `${val}${object.seriesIndex === 2 ? 'K' : ''}`
                  }
                }
              }
            },
            grid: {
              borderColor: "#f1f1f1"
            },
            fill: {
              opacity: 1
            },
            tooltip: {
              y: {
                formatter: function(val, object) {
                  if(current_state.graphType === "percentual") {
                    return `${val}%`
                  } else {
                    return `${parseFloat(val || 0).toLocaleString("pt-br", {
                      style: "currency",
                      currency: "BRL"
                    })}${object.seriesIndex === 2 ? 'K' : ''}`
                  }

                }
              }
            }
          },
          chart_series: [
            {
              name: props.t('dashboard.lista.valorCanal.ticketmedio'),
              data:
                valoresPeriodo
                  ? valoresPeriodo.map(e =>
                    current_state.graphType === "percentual"
                      ? VendasCanal.describePercentage(e.Ticket_Medio_Pessoa || 0, totalizadores.Ticket_Medio_Pessoa)
                      : e.Ticket_Medio_Pessoa)
                  : []
            },
            {
              name: props.t('dashboard.lista.valorCanal.ticketmedioatendimento'),
              data:
                valoresPeriodo
                  ? valoresPeriodo.map(e =>
                    current_state.graphType === "percentual"
                      ? VendasCanal.describePercentage(e.Ticket_Medio || 0, totalizadores.Ticket_Medio)
                      : e.Ticket_Medio)
                  : []
            },
            {
              name: props.t('dashboard.lista.valorCanal.faturamento'),
              data:
                valoresPeriodo
                  ? valoresPeriodo.map(e =>
                    current_state.graphType === "percentual"
                      ? VendasCanal.describePercentage(e.Valor_Total || 0, totalizadores.Valor_Total)
                      : e.Valor_Total ? (e.Valor_Total / 1000) : 0)
                  : []
            },

          ]
        }
      }
    }

    return props
  }

  componentDidMount() {
    this.props.getDashboardData(this.props.dashboardFilters.periodStart,
        this.props.dashboardFilters.periodEnd,
        this.props.dashboardFilters.companiesId, "valoresPorCanal")
  }

  setGraphType(graphType) {
    this.setState(prevState => ({ ...prevState, graphType }))
    this.props.setUserPreference("Grafico_Vendas_Canal", graphType)
  }

  render() {
    return (
      <React.Fragment>
        <Col xl="6">
          <Card>
            <CardBody>
              <div className="d-flex flex-wrap">
                <h4 className="card-title mb-4"> { this.props.t('dashboard.lista.vendascanal.label') } </h4>
                <Tooltip id='vendasdia' tooltip={ this.props.t('dashboard.lista.vendascanal.tooltip') }></Tooltip>
                <div className="ms-auto">
                  <div className="toolbar d-flex flex-wrap gap-2 text-end">
                    <Button
                      color="light"
                      size="sm"
                      type="button"
                      className={
                        this.state.graphType === "percentual" ? "active" : ""
                      }
                      onClick={ () => this.setGraphType("percentual") }
                    >
                      Em Percentual
                    </Button>
                    <Button
                      color="light"
                      size="sm"
                      type="button"
                      className={
                        this.state.graphType === "value" ? "active" : ""
                      }
                      onClick={ () => this.setGraphType("value") }
                    >
                      Em Valor
                    </Button>
                  </div>
                </div>
              </div>
              { this.props.loadingDashboardValoresPorCanal ||
              !this.state.chart_options ||
              !this.state.chart_series ? (
                <div className="loader-container position-absolute">
                  <Loader
                    type="ThreeDots"
                    color="#556EE6"
                    height={ 80 }
                    width={ 80 }
                  />
                </div>
              ) : (
                <div>
                  <ReactApexChart
                    options={ this.state.chart_options }
                    series={ this.state.chart_series }
                    type="bar"
                    height={ 300 }
                  />
                </div>
              ) }
            </CardBody>
          </Card>
        </Col>
      </React.Fragment>
    )
  }
}

VendasCanal.propTypes = {
  loadingDashboardValoresPorCanal: PropTypes.any,
  dashboards: PropTypes.any,
  getDashboardData: PropTypes.func
}

const mapStatetoProps = state => {
  const {
    dashboardData,
    loadingDashboardValoresPorCanal,
    dashboardValoresPorCanal
  } = state.Dashboard
  const {
    dashboards,
    preferences,
    dashboardFilters
  } = state.Login
  return {
    dashboardData,
    dashboardFilters,
    dashboards,
    loadingDashboardValoresPorCanal,
    dashboardValoresPorCanal,
    preferences
  }
}

export default withTranslation()(connect(mapStatetoProps, {
  registerUser,
  apiError,
  registerUserFailed,
  getDashboardData,
  setUserPreference
})(VendasCanal))
